<template>
  <div>
    <span v-sanitise:[!show_full]="formatted_content" />
    <span v-show="show_controls">
      <a v-show="!show_full" :id="dom_id"
         :href="link"
         class="kt-link"
         @click="toggle">{{ moreStr }}</a>
      <a v-show="show_full" :id="dom_id"
         :href="link"
         class="kt-link"
         @click="toggle">{{ lessStr }}</a>
    </span>
  </div>
</template>

<script>

const getNewID = (function () {
  let id_index = 0;
  // return a fn which gives back index, then increments it
  return () => id_index++;
})();

export default {
  props: {
    moreStr: {
      type: String,
      default: `read more`,
    },
    lessStr: {
      type: String,
      default: ``,
    },
    text: {
      type: String,
      required: false,
      default: null,
    },
    link: {
      type: String,
      default: `#`,
    },
    maxChars: {
      type: Number,
      default: 100,
    },
  },
  data: () => ({
    show_full: false,
  }),
  computed: {
    formatted_content() {
      if (this.show_controls && !this.show_full) {
        return `${this.text.substring(0, this.maxChars)}...`;
      }
      return this.text;
    },
    dom_id() {
      return `readmore-${this.id}`;
    },
    raw_text() {
      const dummy_el = document.createElement('span');
      dummy_el.innerHTML = this.text;
      return dummy_el.textContent || dummy_el.innerText;
    },
    show_controls() {
      return this.raw_text.length > this.maxChars;
    },
  },
  beforeMount() {
    this.id = getNewID();
  },
  methods: {
    toggle(ev) {
      if (this.link === `#`) {
        ev.preventDefault();
      }
      if (this.lessStr) this.show_full = !this.show_full;
    },
  },
};
</script>
